<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8">
          <card>
            <form>
              <!-- <div class="row"> -->
              <!-- <div class="col-md-12"> -->
              <!-- Botanical name -->
              <div class="row">
                <div class="col-md-11">
                  <h4 slot="header" class="card-title">Plant Info - {{ data.botanical_name }}</h4>
                </div>

                <div class="col-md-1">
                  <div class="form-group">
                    <button type="submit" class="btn btn-success btn-fill " @click.prevent="save">Save</button>
                  </div>
                </div>
              </div>

              <div class="row status-comment-row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="status" class="property-label">Status</label>
                    <select id="status" class="form-control" v-model="data.status">
                      <option value="1">Verified</option>
                      <option value="0">Not verified</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="comment" class="property-label">Comment</label>
                    <textarea
                      id="comment"
                      v-model="data.comment"
                      class="form-control"
                      rows="3"
                      aria-describedby="addon-right addon-left"
                    >
                    </textarea>
                  </div>
                </div>
              </div>

              <!-- ROW SEPARATOR -->
              <div class="row row-separator">
                <h2><strong>Scientific Classification</strong></h2>
              </div>

              <!-- name -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name" class="property-label">Name</label>
                    <input
                      id="name"
                      v-model="data.name"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>
              <!-- Botanical name -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="botanical_name" class="property-label">Botanical name</label>
                    <input
                      id="botanical_name"
                      v-model="data.botanical_name"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- Common names -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="common_names" class="property-label"
                      >Common names <span class="badge badge-secondary">Array</span></label
                    >
                    <input
                      id="common_names"
                      v-model="data.common_names"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- class -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="class" class="property-label">class</label>
                    <input
                      id="class"
                      v-model="data.class"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- order -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="order" class="property-label">order</label>
                    <input
                      id="class"
                      v-model="data.order"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- family_name -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="family_name" class="property-label">family name</label>
                    <input
                      id="family_name"
                      v-model="data.family_name"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- genus -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="genus" class="property-label">Genus</label>
                    <input
                      id="genus"
                      v-model="data.genus"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>
              <!-- species -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="species" class="property-label">Species</label>
                    <input
                      id="species"
                      v-model="data.species"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- cultivars -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="cultivars" class="property-label"
                      >cultivars <span class="badge badge-secondary">Array</span></label
                    >
                    <input
                      id="cultivars"
                      v-model="data.cultivars"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- ROW SEPARATOR -->
              <div class="row row-separator">
                <h2><strong>Description</strong></h2>
              </div>

              <!-- Description -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="common_names" class="property-label">Description</label>
                    <button
                      type="submit"
                      class="btn btn-success btn-fill "
                      @click.prevent="addArrayItem('description')"
                    >
                      Add new line
                    </button>
                  </div>
                </div>
              </div>

              <!-- description -->
              <div v-for="(item, index) in data.description" v-bind:key="index" class="row">
                <div class="col-md-10">
                  <div class="form-group">
                    <!-- <label for="description" class="property-label">Description {{index + 1}}</label> -->
                    <textarea
                      id="description"
                      v-model="data.description[index]"
                      class="form-control"
                      rows="5"
                      aria-describedby="addon-right addon-left"
                    >
                    </textarea>
                  </div>
                </div>
                <div class="col-md-2">
                  <button
                    type="submit"
                    class="btn btn-danger btn-fill "
                    @click.prevent="removeArrayItem('description', index)"
                  >
                    X
                  </button>
                </div>
              </div>

              <!-- ROW SEPARATOR -->
              <div class="row row-separator">
                <h2><strong>Charasteristics</strong></h2>
              </div>

              <!-- plant_type -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="plant_type" class="property-label"
                      >plant type <span class="badge badge-secondary">Array</span></label
                    >
                    <v-select
                      id="plant_type"
                      aria-describedby="addon-right addon-left"
                      v-model="data.plant_type"
                      :clearable="false"
                      :options="PLANT_TYPES"
                      multiple
                    />
                  </div>
                </div>
              </div>

              <!-- Care -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="care" class="property-label">Care</label>
                    <v-select
                      id="care"
                      aria-describedby="addon-right addon-left"
                      v-model="data.care"
                      :clearable="false"
                      :options="CARE_OPTIONS"
                    />
                  </div>
                </div>
              </div>

              <!-- Water -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="water" class="property-label">Water</label>
                    <input
                      id="water"
                      v-model="data.water"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- light -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="light" class="property-label"
                      >Sun(Light) <span class="badge badge-secondary">Array</span
                      ><span class="subtitle"> Fill in more details, 3 values max</span></label
                    >
                    <v-select
                      id="light"
                      aria-describedby="addon-right addon-left"
                      v-model="data.light"
                      :clearable="false"
                      :options="SUNLIGHT_OPTIONS.filter(option => data.light && data.light.indexOf(option) < 0)"
                      :selectable="() => data.light.length < 3"
                      multiple
                    />
                  </div>
                </div>
              </div>
              <!-- tag light -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="light" class="property-label"
                      >Tag Sun(Light) <span class="badge badge-secondary">Array</span>
                      <span class="subtitle">Filled in automatically</span></label
                    >
                    <input
                      id="light_tag"
                      v-model="getSunlightTag"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                      disabled
                    />
                  </div>
                </div>
              </div>

              <!-- Temperature -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="temperature" class="property-label">Temperature </label>
                    <div style="display: flex; align-items: center;">
                      <input
                        id="minTemp"
                        type="number"
                        v-model="minTemp"
                        class="form-control"
                        aria-describedby="addon-right addon-left"
                        style="width: 60px; margin-right: 8px;"
                      />
                      –
                      <input
                        id="maxTemp"
                        type="number"
                        v-model="maxTemp"
                        class="form-control"
                        aria-describedby="addon-right addon-left"
                        style="width: 60px;margin-left: 8px;"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- soil_type -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="soil_type" class="property-label"
                      >soil type <span class="badge badge-secondary">Array</span></label
                    >
                    <input
                      id="soil_type"
                      v-model="data.soil_type"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>
              <!-- soil_ph -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="soil_ph" class="property-label"
                      >soil ph <span class="badge badge-secondary">Array</span></label
                    >
                    <input
                      id="soil_ph"
                      v-model="data.soil_ph"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>
              <!-- soil_drainage -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="soil_drainage" class="property-label"
                      >soil drainage <span class="badge badge-secondary">Array</span></label
                    >
                    <input
                      id="soil_drainage"
                      v-model="data.soil_drainage"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- Bloom time -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="bloom_time" class="property-label"
                      >Bloom time <span class="badge badge-secondary">Array</span></label
                    >
                    <v-select
                      id="bloom_time"
                      aria-describedby="addon-right addon-left"
                      v-model="data.bloom_time"
                      :clearable="false"
                      :options="BLOOM_OPTIONS"
                      multiple
                    />
                  </div>
                </div>
              </div>

              <!-- height -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="height" class="property-label">height</label>
                    <input
                      id="height"
                      v-model="data.height"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- Spread -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="spread" class="property-label">Spread</label>
                    <input
                      id="spread"
                      v-model="data.spread"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- leaves -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="leaves" class="property-label">leaves</label>
                    <input
                      id="leaves"
                      v-model="data.leaves"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>
              <!-- leaf_color -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="leaf_color" class="property-label">leaf color</label>
                    <input
                      id="leaf_color"
                      v-model="data.leaf_color"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- flower_color -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="flower_color" class="property-label"
                      >flower color <span class="badge badge-secondary">Array</span></label
                    >
                    <input
                      id="flower_color"
                      v-model="data.flower_color"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- hardiness_zone -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="hardiness_zone" class="property-label"
                      >hardiness zone <span class="badge badge-secondary">Array</span></label
                    >
                    <input
                      id="hardiness_zone"
                      v-model="data.hardiness_zone"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- toxicity -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="toxicity" class="property-label"
                      >toxicity <span class="badge badge-secondary">Array</span></label
                    >
                    <input
                      id="toxicity"
                      v-model="data.toxicity"
                      class="form-control"
                      aria-describedby="addon-right addon-left"
                    />
                  </div>
                </div>
              </div>

              <!-- ROW SEPARATOR -->
              <div class="row row-separator">
                <h2><strong>Care Guide</strong></h2>
              </div>

              <!-- How to grow -->
              <CareGuide :guideObject="data.cg_how_to_grow" label="How to grow" />

              <!-- Water -->
              <CareGuide :guideObject="data.cg_water" label="Water" />

              <!-- Light -->
              <CareGuide :guideObject="data.cg_light" label="Light" />

              <!-- Soil -->
              <CareGuide :guideObject="data.cg_soil" label="Soil" />

              <!-- Temperature and Humidity -->
              <CareGuide :guideObject="data.cg_temp_hum" label="Temperature and Humidity" />

              <!-- Fertilizing -->
              <CareGuide :guideObject="data.cg_fertilizing" label="Fertilizing" />

              <!-- Pruning -->
              <CareGuide :guideObject="data.cg_pruning" label="Pruning" />

              <!-- Propagation -->
              <CareGuide :guideObject="data.cg_propagation" label="Propagation" />

              <!-- Potting suggestions & Repotting -->
              <CareGuide :guideObject="data.cg_potting_suggestions" label="Potting suggestions & Repotting" />

              <!-- Pest & Diseases -->
              <CareGuide :guideObject="data.cg_pest_diseases" label="Pest & Diseases" />

              <!-- Toxicity -->
              <CareGuide :guideObject="data.cg_toxicity" label="Toxicity" />

              <!-- propagation
                                     <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="propagation" class="property-label">propagation</label>
                                                <input
                                                        id="propagation"
                                                        v-model="data.propagation"
                                                        class="form-control"
                                                        aria-describedby="addon-right addon-left">
                                            </div>
                                        </div>
                                    </div>
                                    
                                    
                                     -->
              <!-- poisonous
                                     <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="poisonous" class="property-label">poisonous</label>
                                                <input
                                                        id="poisonous"
                                                        v-model="data.poisonous"
                                                        class="form-control"
                                                        aria-describedby="addon-right addon-left">
                                            </div>
                                        </div>
                                    </div>
                                     -->

              <!-- spread
                                     <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="spread" class="property-label">spread</label>
                                                <input
                                                        id="class"
                                                        v-model="data.spread"
                                                        class="form-control"
                                                        aria-describedby="addon-right addon-left">
                                            </div>
                                        </div>
                                    </div> -->

              <!-- pruning
                                     <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="pruning" class="property-label">pruning</label>
                                                <input
                                                        id="class"
                                                        v-model="data.pruning"
                                                        class="form-control"
                                                        aria-describedby="addon-right addon-left">
                                            </div>
                                        </div>
                                    </div> -->

              <!-- fertilizer
                                     <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="fertilizer" class="property-label">fertilizer</label>
                                                <input
                                                        id="class"
                                                        v-model="data.fertilizer"
                                                        class="form-control"
                                                        aria-describedby="addon-right addon-left">
                                            </div>
                                        </div>
                                    </div>
                                        -->

              <!-- </div> -->

              <!-- </div> -->
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Card from 'src/components/UIComponents/Cards/Card.vue'
import CareGuide from 'src/components/Dashboard/Views/Plants/templates/CareGuide.vue'

export default {
  components: {
    Card,
    CareGuide,
  },
  data() {
    return {
      data: {},
      id: 0,
      token: localStorage.getItem('token'),
      minTemp: 0,
      maxTemp: 0,
      CARE_OPTIONS: ['Easy', 'Medium', 'Hard'],
      SUNLIGHT_OPTIONS: [
        'Partial Shade',
        'Deep shade',
        'Dappled Sunlight',
        'Bright',
        'Indirect light',
        'Full sun',
        'Part-Full',
        'Part sun',
      ],
      PLANT_TYPES: [
        'Annual',
        'Bulb',
        'Cactaceae',
        'Cactus',
        'Carnivorous',
        'Climber',
        'Cool Season Vegetable',
        'Creeping',
        'Edible',
        'Endemic',
        'Epiphyte',
        'Evergreen',
        'Fern',
        'Flowering',
        'Foliage Plants',
        'Grass',
        'Ground Cover',
        'Herb',
        'Herbaceous Perennial',
        'Houseplant',
        'Mushroom',
        'Native Plant',
        'Ornamental',
        'Ornamental Grasses and Sedges',
        'Palm',
        'Perennial',
        'Poisonous',
        'Rhizomatous',
        'Rose',
        'Shrub',
        'Subtropical subshrub',
        'Succulent',
        'Terrestrial Herb',
        'Tree',
        'Turfgrass',
        'Vegetable',
        'Vine',
        'Warm Season',
        'Warm Season Vegetable',
        'Water Plant',
        'Weed',
        'Wildflower',
        'Woody',
      ],
      BLOOM_OPTIONS: [
        'Summer',
        'Spring',
        'Winter',
        'Fall',
        'All year around',
        'Mid summer',
        'Mid winter',
        'Late winter',
        'Non-flowering',
      ],
      array_fields: [
        'common_names',
        'bloom_time',
        'flower_color',
        'hardiness_zone',
        'soil_type',
        'soil_ph',
        'soil_drainage',
        'toxicity',
        'light',
        'cultivars',
        'plant_type',
      ],
    }
  },
  computed: {
    getSunlightTag() {
      const lightModes = this.data.light
      const ifEveryThen = (lightArr, result) =>
        lightArr.every(lightMode => lightModes && lightModes.includes(lightMode)) ? result : false

      const result =
        lightModes && lightModes[0]
          ? ifEveryThen(['Partial Shade', 'Deep shade', 'Dappled Sunlight'], 'Part sun') ||
            ifEveryThen(['Partial Shade', 'Deep shade', 'Part sun'], 'Part sun') ||
            ifEveryThen(['Partial Shade', 'Deep shade', 'Bright'], 'Partial Shade') ||
            ifEveryThen(['Partial Shade', 'Deep shade', 'Indirect light'], 'Partial Shade') ||
            ifEveryThen(['Partial Shade', 'Deep shade', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Partial Shade', 'Deep shade', 'Part-Full'], 'Partial Shade') ||
            ifEveryThen(['Partial Shade', 'Dappled Sunlight', 'Part sun'], 'Part sun') ||
            ifEveryThen(['Partial Shade', 'Dappled Sunlight', 'Bright'], 'Partial Shade') ||
            ifEveryThen(['Partial Shade', 'Dappled Sunlight', 'Indirect light'], 'Part sun') ||
            ifEveryThen(['Partial Shade', 'Dappled Sunlight', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Partial Shade', 'Dappled Sunlight', 'Part-Full'], 'Part sun') ||
            ifEveryThen(['Partial Shade', 'Part sun', 'Bright'], 'Part sun') ||
            ifEveryThen(['Partial Shade', 'Part sun', 'Indirect light'], 'Part sun') ||
            ifEveryThen(['Partial Shade', 'Part sun', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Partial Shade', 'Part sun', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Partial Shade', 'Bright', 'Indirect light'], 'Part sun') ||
            ifEveryThen(['Partial Shade', 'Bright', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Partial Shade', 'Bright', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Partial Shade', 'Indirect light', 'Full sun'], 'Partial Shade') ||
            ifEveryThen(['Partial Shade', 'Indirect light', 'Part-Full'], 'Part sun') ||
            ifEveryThen(['Partial Shade', 'Full sun', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Deep shade', 'Dappled Sunlight', 'Part sun'], 'Part sun') ||
            ifEveryThen(['Deep shade', 'Dappled Sunlight', 'Bright'], 'Part sun') ||
            ifEveryThen(['Deep shade', 'Dappled Sunlight', 'Indirect light'], 'Part sun') ||
            ifEveryThen(['Deep shade', 'Dappled Sunlight', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Deep shade', 'Dappled Sunlight', 'Part-Full'], 'Part sun') ||
            ifEveryThen(['Deep shade', 'Part sun', 'Bright'], 'Part sun') ||
            ifEveryThen(['Deep shade', 'Part sun', 'Indirect light'], 'Part sun') ||
            ifEveryThen(['Deep shade', 'Part sun', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Deep shade', 'Part sun', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Deep shade', 'Bright', 'Indirect light'], 'Part sun') ||
            ifEveryThen(['Deep shade', 'Bright', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Deep shade', 'Bright', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Deep shade', 'Indirect light', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Deep shade', 'Indirect light', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Deep shade', 'Full sun', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Deep shade', 'Part sun', 'Full sun'], 'Part sun') ||
            ifEveryThen(['Dappled Sunlight', 'Part sun', 'Indirect light'], 'Part sun') ||
            ifEveryThen(['Dappled Sunlight', 'Part sun', 'Full sun'], 'Part sun') ||
            ifEveryThen(['Dappled Sunlight', 'Part sun', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Dappled Sunlight', 'Bright', 'Indirect light'], 'Part sun') ||
            ifEveryThen(['Dappled Sunlight', 'Bright', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Dappled Sunlight', 'Bright', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Dappled Sunlight', 'Indirect light', 'Full sun'], 'Part sun') ||
            ifEveryThen(['Dappled Sunlight', 'Indirect light', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Dappled Sunlight', 'Full sun', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Part sun', 'Bright', 'Indirect light'], 'Part sun') ||
            ifEveryThen(['Part sun', 'Bright', 'Full sun'], 'Part sun') ||
            ifEveryThen(['Part sun', 'Bright', 'Part-Full'], 'Part sun') ||
            ifEveryThen(['Part sun', 'Indirect light', 'Full sun'], 'Part sun') ||
            ifEveryThen(['Part sun', 'Indirect light', 'Part-Full'], 'Part sun') ||
            ifEveryThen(['Part sun', 'Full sun', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Bright', 'Indirect light', 'Full sun'], 'Indirect light') ||
            ifEveryThen(['Bright', 'Indirect light', 'Part-Full'], 'Part sun') ||
            ifEveryThen(['Bright', 'Full sun', 'Part-Full'], 'Full sun') ||
            ifEveryThen(['Indirect light', 'Full sun', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Partial Shade', 'Deep shade'], 'Partial Shade') ||
            ifEveryThen(['Partial Shade', 'Dappled Sunlight'], 'Part sun') ||
            ifEveryThen(['Partial Shade', 'Part sun'], 'Part sun') ||
            ifEveryThen(['Partial Shade', 'Bright'], 'Part sun') ||
            ifEveryThen(['Partial Shade', 'Indirect light'], 'Partial Shade') ||
            ifEveryThen(['Partial Shade', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Partial Shade', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Deep shade', 'Part sun'], 'Partial Shade') ||
            ifEveryThen(['Deep shade', 'Bright'], 'Partial Shade') ||
            ifEveryThen(['Deep shade', 'Indirect light'], 'Partial Shade') ||
            ifEveryThen(['Deep shade', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Deep shade', 'Part-Full'], 'Partial Shade') ||
            ifEveryThen(['Deep shade', 'Dappled Sunlight'], 'Partial Shade') ||
            ifEveryThen(['Dappled Sunlight', 'Part sun'], 'Part sun') ||
            ifEveryThen(['Dappled Sunlight', 'Bright'], 'Part sun') ||
            ifEveryThen(['Dappled Sunlight', 'Indirect light'], 'Part sun') ||
            ifEveryThen(['Dappled Sunlight', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Dappled Sunlight', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Part sun', 'Bright'], 'Part sun') ||
            ifEveryThen(['Part sun', 'Indirect light'], 'Part sun') ||
            ifEveryThen(['Part sun', 'Full sun'], 'Part sun') ||
            ifEveryThen(['Part sun', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Bright', 'Indirect light'], 'Indirect light') ||
            ifEveryThen(['Bright', 'Full sun'], 'Full sun') ||
            ifEveryThen(['Bright', 'Part-Full'], 'Part-Full') ||
            ifEveryThen(['Indirect light', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Indirect light', 'Full sun'], 'Part-Full') ||
            ifEveryThen(['Full sun', 'Part-Full'], 'Part-Full') ||
            lightModes[0]
          : ''

      return result
    },
  },
  created: function() {
    this.id = this.$route.params.id
    this.getInfo(this.id)
  },
  methods: {
    getInfo: async function() {
      let self = this
      let token = localStorage.getItem('token')

      const { data } = await axios.get(`${this.$hostname}/admin/plants/${self.id}`, {
        headers: {
          Authorization: token,
        },
      })

      self.data = data

      const minMaxTemp = data.temperature.split('-').filter(Boolean)

      const isNegativeFirstTemp = data.temperature.charAt(0) === '-'
      const isNegativeBothTemp = data.temperature.split('-').length === 4

      self.minTemp = isNegativeFirstTemp ? -minMaxTemp[0] : minMaxTemp[0]
      self.maxTemp = isNegativeBothTemp ? -minMaxTemp[1] : minMaxTemp[1]

      document.title = `${data.botanical_name}`
    },

    isJson: function(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }

      return true
    },
    // addInfoSection: function () {
    //     this.data.info = {
    //         ...{
    //             title: '',
    //             images: [],
    //             free_text: [],
    //             paid_text: []
    //         }
    //     };
    // },
    // removeInfoSection: function () {
    //     this.data.info = null;
    // },
    removeInfoImageItem: function(field, imgIndex) {
      this.data[field].images.splice(imgIndex, 1)
    },

    addArrayItem: function(field, type) {
      if (type === 'free_text' || type === 'paid_text') {
        this.data[field][type].push('')
      } else {
        this.data[field].push('')
      }
    },
    removeArrayItem: function(field, index, type) {
      if (type === 'free_text' || type === 'paid_text') {
        this.data[field][type].splice(index, 1)
      } else {
        this.data[field].splice(index, 1)
      }
    },
    goBack: function() {
      window.history.back()
    },
    save: async function() {
      let self = this

      //// temp validation
      if (!this.minTemp || (this.maxTemp && parseFloat(this.minTemp) > parseFloat(this.maxTemp))) {
        const notification = {
          template: `<span><b>The maximum temperature cannot be less than the minimum temperature!</b></span>`,
        }

        self.$notifications.notify({
          component: notification,
          icon: 'nc-icon nc-simple-remove',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: 'danger',
        })
        return
      }

      // Prepare array fields

      for (const field of this.array_fields) {
        if (typeof this.data[field] === 'string') {
          if (this.data[field].length > 0) {
            this.data[field] = this.data[field].split(',')
          } else {
            this.data[field] = []
          }
        }
      }

      // if (Number(this.object.push_payload.type) === 2 && !Number(this.object.push_payload.id)) {
      //     self.$notifications.notify(
      //             {
      //                 component: {template: `<span><b>Push item id required</b></span>`},
      //                 icon: 'nc-icon nc-simple-remove',
      //                 horizontalAlign: 'right',
      //                 verticalAlign: 'top',
      //                 type: 'danger'
      //             })

      //     return false;
      // }

      this.$loading.show({ delay: 0 })

      const light_tag = this.getSunlightTag
      const temperature = this.maxTemp ? `${this.minTemp}-${this.maxTemp}` : this.minTemp

      const formattedData = { ...this.data, temperature, light_tag }

      axios
        .post(`${this.$hostname}/admin/plants/${self.id}/save`, formattedData, {
          headers: {
            Authorization: self.token,
          },
        })
        .then(function(response) {
          const notification = {
            template: `<span><b>Info saved</b></span>`,
          }

          self.$notifications.notify({
            component: notification,
            icon: 'nc-icon nc-explore-2',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'info',
          })
        })
        .catch(function(error) {
          const notification = {
            template: `<span><b>${error.response.data.message}</b></span>`,
          }

          self.$notifications.notify({
            component: notification,
            icon: 'nc-icon nc-simple-remove',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'danger',
          })
        })
        .finally(function() {
          self.$loading.hide()
        })
    },

    uploadFile: function(event, field = null) {
      let self = this

      let formData = new FormData()

      formData.append('file', event.target.files[0])

      this.$loading.show({ delay: 0 })

      axios
        .post(`${this.$hostname}/admin/services/photo/upload`, formData, {
          headers: {
            Authorization: self.token,
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(function({ data }) {
          if (field) {
            self.data[field].images.push(data.url)
          }
        })
        .catch(function(error) {
          console.log(error)
          const notification = {
            template: `<span><b>Error uploading.</b></span>`,
          }

          self.$notifications.notify({
            component: notification,
            icon: 'nc-icon nc-simple-remove',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'danger',
          })
        })
        .finally(function() {
          self.$loading.hide()
        })
    },
  },
}
</script>
<style scoped>
.property-label {
  font-size: 15px;
  color: black;
  font-weight: bold;
}
button:disabled,
button[disabled] {
  cursor: not-allowed;
}

.btn-save {
  width: 150px;
}

.col-md-4 {
  padding: 15px !important;
}

.checkbox-block {
  margin-top: 40px;
  margin-left: 40px;
}

.btn-file {
  display: none;
}

.image-block {
  max-width: 100%;
}

.form-check-inline {
  display: inline-block;
}

.label-checkbox {
  margin-right: 10px;
}

.link {
  cursor: pointer;
  text-decoration: underline;
}
.card-body p {
  font-weight: 300;
  font-style: italic;
}

.card-body form {
  /*margin-top: 15px;*/
}

/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #ccc;
}

.subtitle {
  font-size: 14px;
  font-weight: 500;
  color: #636363;
  text-transform: none;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  opacity: 0.8;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #54abfe;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.preview-device {
  display: inline-block;
  width: 32%;
  margin-left: 10px;
}
.device-block {
  position: relative;
  background-position: center center;
  background-size: cover;
  cursor: pointer;
}
.device-block.inactive {
  opacity: 0.5;
}
.device-block span {
  position: absolute;
  top: -30px;
  left: 5px;
}
.device-block img {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 18px;
  top: 18px;
}
.device1 {
  display: inline-block;
  /*width: 281px;*/
  /*height: 609px;*/
  width: 337px;
  height: 731px;
  border: 3px solid #000;
  border-radius: 10px;
  margin-left: 40px;
}
.device2 {
  display: inline-block;
  /*width: 310px;*/
  /*height: 552px;*/
  width: 372px;
  height: 662px;
  border: 3px solid #000;
  border-radius: 10px;
  margin-left: 50px;
}
.device3 {
  display: inline-block;
  /*width: 384px;*/
  /*height: 512px;*/
  width: 461px;
  height: 614px;
  border: 3px solid #000;
  border-radius: 10px;
  margin-left: 50px;
}
.mt30 {
  margin-top: 30px;
}
.section-row {
  border: 1px solid #e3e3e3;
  margin: 1px;
  padding: 20px;
  display: block;
}
.s-row {
  align-items: self-end;
}
.images-col {
  max-width: 100%;
  margin-bottom: 20px;
}
.images-row {
  border: 1px solid #e3e3e3;
  margin: 1px;
  padding: 20px;
  /* display: block;  */
}
.img-item {
  /* элемент тени */
  cursor: pointer;
  -webkit-box-shadow: 0 5px 2px -3px rgba(0, 0, 0, 0.1), 0 1px 0px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 5px 2px -3px rgba(0, 0, 0, 0.1), 0 1px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 0 5px 2px -3px rgba(0, 0, 0, 0.1), 0 1px 0px rgba(0, 0, 0, 0.1);
}
.img-item:hover {
  /* элемент тени если наведен курсор */
  -webkit-box-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.5), 0 1px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.5), 0 1px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.3), 0 1px 0px rgba(0, 0, 0, 0.1);
  /* элемент тени если наведен курсор конец */
}
.row-separator {
  margin-top: 0px;
  margin-bottom: 10px;
  margin-left: 0px;
}
.status-comment-row {
  justify-content: space-between;
}

input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Plants/PlantInfo.vue